import React, { useState } from 'react';
import { COLORS, SPACING } from '../styles/theme';
import { publishEvent } from '../lib/sync';
import { ReportReason, ReportTargetType } from '../lib/moderation';

const REASONS: Array<{ value: ReportReason; label: string }> = [
  { value: 'spam', label: 'Spam' },
  { value: 'harassment', label: 'Harassment' },
  { value: 'illegal', label: 'Illegal content' },
  { value: 'other', label: 'Other' },
];

interface Props {
  targetId: string;
  targetType: ReportTargetType;
}

export function ReportButton({ targetId, targetType }: Props) {
  const [open, setOpen] = useState(false);
  const [sent, setSent] = useState(false);

  const stop = (e: React.MouseEvent) => e.stopPropagation();

  const submit = async (reason: ReportReason) => {
    await publishEvent('content_report', { targetId, targetType, reason });
    setOpen(false);
    setSent(true);
    setTimeout(() => setSent(false), 2000);
  };

  if (sent) {
    return <span style={{ color: COLORS.highlight, fontFamily: '"IBM Plex Mono", monospace', fontSize: '11px' }}>✓ reported</span>;
  }

  return (
    <div style={{ position: 'relative' }} onClick={stop}>
      <button
        onClick={() => setOpen(v => !v)}
        style={{ background: 'none', border: 'none', color: COLORS.textMuted, cursor: 'pointer', fontFamily: '"IBM Plex Mono", monospace', fontSize: '11px', padding: 0 }}
      >
        ⚑ report
      </button>
      {open && (
        <div style={{
          position: 'absolute', bottom: '100%', left: 0, marginBottom: SPACING.xs,
          backgroundColor: COLORS.panel, border: `1px solid ${COLORS.border}`,
          zIndex: 10, minWidth: 140,
        }}>
          {REASONS.map(r => (
            <button
              key={r.value}
              onClick={() => submit(r.value)}
              style={{
                display: 'block', width: '100%', padding: SPACING.sm,
                background: 'none', border: 'none', borderBottom: `1px solid ${COLORS.border}`,
                color: COLORS.text, cursor: 'pointer', textAlign: 'left',
                fontFamily: '"IBM Plex Mono", monospace', fontSize: '10px',
              }}
            >
              {r.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
